import { render, staticRenderFns } from "./pcWechatLogin.vue?vue&type=template&id=3db48046&scoped=true&"
import script from "./pcWechatLogin.vue?vue&type=script&lang=js&"
export * from "./pcWechatLogin.vue?vue&type=script&lang=js&"
import style0 from "./pcWechatLogin.vue?vue&type=style&index=0&id=3db48046&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db48046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3db48046', component.options)
    } else {
      api.reload('3db48046', component.options)
    }
    module.hot.accept("./pcWechatLogin.vue?vue&type=template&id=3db48046&scoped=true&", function () {
      api.rerender('3db48046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pcWechatLogin.vue"
export default component.exports